import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { myConstants } from '../../shares/Constants'

export const ClubApi = createApi({
  reducerPath: 'ClubApi',
  tagTypes: [
    'Clubs',
    'ClubRegistrations',
    'ClubRegistration',
    'Contacts',
  ],

  baseQuery: fetchBaseQuery({
    // Fill in your own server starting URL here
    baseUrl: myConstants.baseURL,
    prepareHeaders: (headers, { getState }) => 
    {        
      const token = getState().auth.token;
      // console.log("prepare-header:" + token);
      if (token) 
      {
        headers.set('Authorization', `token ${token}`);
      }
      return headers;      
    },    
  }),

  endpoints: (build) => ({
    fetchClubs: 
      build.query(
        {
          query: (year) => 
          ({
            url: myConstants.endpoints.api.base + year + myConstants.endpoints.api.clubs,
            method: 'GET',
          }),
          providesTags: (result, error,year) =>
          [
            {
              type: 'Clubs',
              id: `${year}`
            }
          ]
        }
      ),

    fetchClubsToAdd:
      build.query(
        {
          query: (year) => 
          ({
            url: 
                myConstants.endpoints.api.base 
              + year 
              + myConstants.endpoints.api.clubs 
              + myConstants.endpoints.actions.clubs.list,
            method: 'GET',
          }),
        }
      ),

    fetchSingleClub: 
      build.query(
        {
          query: (year, clubId) => 
          (
            {
              url:  myConstants.endpoints.api.base 
                  + year 
                  + myConstants.endpoints.api.club 
                  + clubId,
              method: 'GET',
            }
          ),
        }
      ),

    addClub: 
      build.mutation(
        {
          query: (content) => 
          (
            {
              url:  myConstants.endpoints.api.base 
                  + content.year 
                  + '/'
                  + myConstants.endpoints.actions.club.add,
              method: 'POST',        
              body:                
              {
                ...content
              },              
            }
          ),
          invalidatesTags: (result, error, content) =>
          [
            {
              type: 'Clubs', 
              id: `${content.year}`
            },
            {
              type: 'ClubRegistrations',
              id: `${content.year}`
            },
          ]
        }
      ), 

    fetchClubUsers: 
      build.query(
        {
          query: (clubKey) => 
          (
            {
              url:  myConstants.endpoints.api.base 
                  + clubKey.year 
                  + myConstants.endpoints.api.club 
                  + clubKey.id
                  + myConstants.endpoints.api.users,
              method: 'GET',
            }
          ),
        }
      ),

    addClubUsers:
      build.mutation(
        {
          query: (content) => 
          (
            {
              url:  myConstants.endpoints.api.base 
                  + content.year 
                  + myConstants.endpoints.api.club   
                  + content.clubId
                  + myConstants.endpoints.api.users
                  + myConstants.endpoints.actions.roles.add,

              method: 'POST',        
              body:                
              {
                ...content
              },              
            }
          ),
          invalidatesTags: (result, error, content) =>
          [
            {
              type: 'Clubs', 
              id: `${content.year}`
            },
            {
              type: 'ClubRegistrations',
              id: `${content.year}`
            },
            { 
              type: 'ClubRegistration', 
              id: `${content.year}-${content.clubId}` 
            },
          ],
        }
      ), 


    updateClubUsers:
      build.mutation(
        {
          query: (content) => 
          (
            {
              url:  myConstants.endpoints.api.base 
                  + content.year 
                  + myConstants.endpoints.api.club   
                  + content.clubId
                  + myConstants.endpoints.api.users
                  + myConstants.endpoints.actions.roles.update,

              method: 'PATCH',        
              body:                
              {
                ...content
              },              
            }
          ),
          invalidatesTags: (result, error, content) => 
          [
            { 
              type: 'ClubRegistration', 
              id: `${content.year}-${content.clubId}` 
            },
          ],
        }
      ),

    rmvClubUsers:
      build.mutation(
        {
          query: (content) => 
          (
            {
              url:  myConstants.endpoints.api.base 
                  + content.year 
                  + myConstants.endpoints.api.club   
                  + content.clubId
                  + myConstants.endpoints.api.user
                  + content.userId
                  + myConstants.endpoints.actions.roles.remove,

              method: 'DELETE',                              
              body:                
              {
                ...content
              },
            }
          ),
          invalidatesTags: (result, error, content) => 
          [
            { 
              type: 'ClubRegistration', 
              id: `${content.year}-${content.clubId}` 
            },
          ],
        }
      ),

    updateClub:
      build.mutation(
        {
          query: (content) => 
          (
            {
              url:  myConstants.endpoints.api.base 
                  + content.year 
                  + myConstants.endpoints.api.club   
                  + content.club.id
                  + '/',      
              method: 'PATCH',        
              body: {
                club:
                { 
                  ...content.club
                },
                update: 
                {
                  ...content.update
                },
              }
            }
          ),
          invalidatesTags: (result, error, content) =>
          [
            {
              type: 'Clubs', 
              id: `${content.year}`
            },
          ],
        }
      ),



    /* 
     * Ermittelt alle aktuellen Anmeldungen inklusive Vereinsdaten
    */
    fetchClubsRegistrations:
      build.query(
        {
          query: (year) => 
          (
            {
            url:  myConstants.endpoints.api.base 
                + year 
                + myConstants.endpoints.api.clubs 
                + myConstants.endpoints.api.registration,
            method: 'GET',
          }
          ),

          providesTags: (result, error, year) => 
          [
            { 
              type: 'ClubRegistrations', id: `${year}` 
            }
          ],
        }
      ),      

    /*
     * Ermitteln aller Benutzer-Emails für das gesamte Turnier
    */  
    fetchAllContacts:
      build.query(
        {
          query: (year) => (
            {
              url:  myConstants.endpoints.api.base 
                  + year
                  + myConstants.endpoints.api.users,
              methods: 'GET',
            }
          ),
          providesTags: (result, error, year) => 
          [
            { 
              type: 'Contacts',
              id: `${year}`
            }
          ],
        }
      ),

    /* 
     * Ermittelt nur eine einzelne Anmeldung eines Vereins
    */  
    fetchClubRegistration: 
      build.query(
        {
          query: (clubKey) => 
          (
            {
              url:  myConstants.endpoints.api.base 
                  + clubKey.year 
                  + myConstants.endpoints.api.club 
                  + clubKey.id
                  + '/'
                  + myConstants.endpoints.api.registration,
              method: 'GET',
            }
          ),

          providesTags: (result, error, clubKey) => 
          [
            { 
              type: 'ClubRegistration', id: `${clubKey.year}-${clubKey.id}` 
            }
          ],
        }
      ),


    setClubRegistration:
      build.mutation(
        {
          query: (registration) => 
          (
            {
              url:  myConstants.endpoints.api.base 
                  + registration.tournament_id 
                  + myConstants.endpoints.api.club 
                  + registration.club_id
                  + '/'
                  + myConstants.endpoints.api.registration,
              method: 'PATCH',        
              body: 
              {
                ...registration
              }
            }
          ),

          invalidatesTags: (result, error, registration) => 
          [
            { 
              type: 'ClubRegistration', id: `${registration.tournament_id}-${registration.club_id}` 
            },
            { 
              type: 'ClubRegistrations', id: `${registration.tournament_id}` 
            }
          ],
        }
      ),  

    updateClubLogo:
      build.mutation(
        {
          query: ({tournament_id, club_id, file}) => 
          {
            const body = new FormData();
            body.append('Content-Type', file.type);
            body.append('file', file);

            return {
              url:  myConstants.endpoints.api.base 
                  + tournament_id
                  + myConstants.endpoints.api.club 
                  + club_id
                  + myConstants.endpoints.actions.club.logo.add,
              method: 'POST',                      
              formData: true,
              body,
            }
          },
        }
      ),
      
    toggleEmailValidity: 
      build.mutation(
        {
          query: 
          (
            {
              year, 
              clubId, 
              userId
            }
          ) => 
          (
            {
              url:  myConstants.endpoints.api.base
                  + year
                  + myConstants.endpoints.api.club
                  + clubId
                  + myConstants.endpoints.api.user
                  + userId
                  + '/'
                  + myConstants.endpoints.actions.user.emailValidity,
              method: 'PATCH',
            }
          ),
          invalidatesTags: (result, error, data) =>
          [
            {
              type: 'Contacts',
              id: `${data.year}`
            }
          ],
        }
      ),
  }),
})

export const 
{ 
  useFetchClubsQuery, 
  useFetchClubsToAddQuery,
  useLazyFetchClubsQuery, 
  usePrefetch, 
  useFetchSingleClubQuery, 
  useAddClubMutation,
  useFetchClubUsersQuery,  
  useLazyFetchClubUsersQuery,
  useUpdateClubMutation ,
  useAddClubUsersMutation,  
  useUpdateClubUsersMutation,
  useRmvClubUsersMutation,
  useFetchClubRegistrationQuery,    
  useFetchClubsRegistrationsQuery,
  useLazyFetchClubRegistrationQuery,
  useSetClubRegistrationMutation,
  useUpdateClubLogoMutation,
  useFetchAllContactsQuery,
  useToggleEmailValidityMutation,
} = ClubApi